;(function () {
	const controlMegaMenu = (header) => {
		const megaMenuLinks = header.querySelectorAll('.list-menu--megamenu')
		if (!megaMenuLinks || !megaMenuLinks.length) return

		megaMenuLinks.forEach((link) => {
			link.addEventListener('mouseenter', () => {
				link.classList.add('list-menu--megamenu-visible')

				link.addEventListener('mousemove', () => {
					link.classList.add('list-menu--megamenu-visible')
				})

				link.addEventListener('mouseleave', () => {
					link.classList.remove('list-menu--megamenu-visible')
					link.addEventListener('mouseenter', () => {
						link.classList.add('list-menu--megamenu-visible')
					})
				})
			})
		})
	}

	const calcMegaMenuPosition = (header) => {
		const isBottomMenuType = Boolean(header.querySelector("header.header--bottom-menu"))
		if (!isBottomMenuType) return

		const megaMenuLinks = header.querySelectorAll('.list-menu--megamenu')
		if (!megaMenuLinks || !megaMenuLinks.length) return

		const headerBottom = header.querySelector('.header__bottom')
		if (!headerBottom) return

		const headerBottomRect = headerBottom.getBoundingClientRect()

		megaMenuLinks.forEach((link) => {
			const menuLi = link.querySelector('.header__mega-menu')
			const headerLi = link.querySelector('.header__menu-item')

			if (!menuLi || !headerLi) return

			const headerRect = headerLi.getBoundingClientRect()

			const verticalDistance = Math.abs(
				headerRect.bottom - headerBottomRect.bottom
			)

			menuLi.style.top = `calc(100% - ${verticalDistance}px)`
		})
	}

	const controlMegaSubmenu = (header) => {
		const megaSubmenuLinks = header.querySelectorAll('.list-menu--megasubmenu')
		megaSubmenuLinks.forEach((link) => {
			link.addEventListener('mouseenter', () => {
				link.classList.add('list-menu--megasubmenu-visible')

				link.addEventListener('mousemove', () => {
					link.classList.add('list-menu--megasubmenu-visible')
				})

				link.addEventListener('mouseleave', () => {
					link.classList.remove('list-menu--megasubmenu-visible')
					link.addEventListener('mouseenter', () => {
						link.classList.add('list-menu--megasubmenu-visible')
					})
				})
			})

			const tabs = link.querySelectorAll('.mega-submenu__tab')
			const submenus = link.querySelectorAll('.mega-submenu__submenu')

			const onToggle = (event) => {
				const tab = event.target
				if (!tab || !tab.classList.contains('mega-submenu__tab')) return
				const tabId = tab.dataset.tabId

				tabs.forEach((tab) => {
					tab.classList.remove('active')
				})
				tab.classList.add('active')
				submenus.forEach((submenu) => {
					submenu.classList.remove('active')
					if (submenu.dataset.tabId === tabId) {
						submenu.classList.add('active')
					}
				})
			}
		
			tabs.forEach((tab) => {
				tab.addEventListener('click', onToggle)
				tab.addEventListener('mouseenter', onToggle)
			})
		})
	}

	const checkMegaSubmenuPosition = (header) => {
		const megaSubmenuLinks = header.querySelectorAll('.list-menu--megasubmenu')
		const headerRect = header.getBoundingClientRect();

		megaSubmenuLinks.forEach((link) => {
			const megaSubmenu = link.querySelector('.mega-submenu')
			megaSubmenu.style.removeProperty("max-width");

			const linkRect = link.getBoundingClientRect();
			const availableWidth = headerRect.right - linkRect.left
			if (availableWidth < 1000) {
				megaSubmenu.style.maxWidth  = `calc(${availableWidth}px - 16px)`;
			}
		});
	};

	const calcHeaderHeightTop = (header) => {
		const headerTop = document.querySelector('.shopify-section-header .header__top');
		if (!headerTop) return;

		const headerTopHeight = header.getBoundingClientRect().height.toFixed(4);
		document.documentElement.style.setProperty('--header-height-top', `${headerTopHeight}px`);
	}

	const calcSearchModalPosition = (header) => {
		const headerWrapper = header.querySelector('.header-wrapper ');
		const searchEl = header.querySelector('.header__search.search');
		const searchModal = searchEl.querySelector('.search__modal');
		if (!headerWrapper || !searchEl || !searchModal) return;

		searchModal.style.removeProperty("left");

		const searchElRect = searchEl.getBoundingClientRect();
		const searchModalRect = searchModal.getBoundingClientRect();
		const headerRect = headerWrapper.getBoundingClientRect();

		if (window.innerWidth >= 1100 && searchModalRect.right > headerRect.right) {
			const searchElCenter = searchElRect.left + searchElRect.width / 2;
			const desiredLeft = searchElCenter - searchModalRect.width / 2;

			let finalLeft = desiredLeft;

			if (finalLeft < headerRect.left) {
				finalLeft = headerRect.right - searchModalRect.width;
			}

			const offsetLeft = finalLeft - searchElRect.left;
			searchModal.style.left = `${offsetLeft}px`;
		}
	}

	const initHeader = () => {
		const header = document.querySelector(".shopify-section-header");
		const headerTop = document.querySelector( ".shopify-section-header .header__top" );
		const headerSearch = document.querySelector( ".shopify-section-header .search__content" );
		const headerBottom = document.querySelector(".shopify-section-header .header__bottom");

      
		if (!header) return

		controlMegaMenu(header)
		controlMegaSubmenu(header)

		const addBackground = () => {
			if (document.querySelector(".overflow-hidden-drawer")) {
				return;
			}

			if (document.querySelector(".always-show")) {
				return;
			}

			const headerObserver = new ResizeObserver((entries) => {
				const [entry] = entries;
				//if (entry.contentRect.width >= 1100) {
					if (
						header.classList.contains("color-background-3") &&
						!header.classList.contains("shopify-section-header-sticky")
					) {
						header.classList.remove("color-background-3");
						headerTop.classList.remove("color-background-3");
						headerBottom?.classList?.remove("color-background-3");
						headerSearch.classList.remove("color-background-3");
					}

					if (
						header.classList.contains("section--have-overlay") &&
						!header.classList.contains("shopify-section-header-sticky")
					) {
						header.classList.add("have-background");
					}
				//}
			});

			headerObserver.observe(header);
		};

		const removeBackground = () => {

			if (
				document.querySelector(".overflow-hidden") ||
				document.querySelector(".overflow-hidden-drawer")
			) {
				return;
			}

			if (document.querySelector(".always-show")) {
				return;
			}

			const hasOpenDetails = header.querySelector("details[open]") !== null;
      const searchElement = header
        .querySelector(".header__overlay")
        .classList.contains("visible");
      const disclosureElement = header.querySelector(
        ".disclosure__button[aria-expanded='true']"
      );

      if (hasOpenDetails || searchElement || disclosureElement) return;

			const headerObserver = new ResizeObserver((entries) => {
				const [entry] = entries;
				//if (entry.contentRect.width >= 1100) {
					if (
						header.classList.contains("color-background-1") &&
						!header.classList.contains("shopify-section-header-sticky")
					) {
						header.classList.add("color-background-3");
						headerTop.classList.add("color-background-3");
						headerSearch.classList.add("color-background-3");
						headerBottom?.classList?.add("color-background-3");
					}

					if (
						header.classList.contains("section--have-overlay") &&
						!header.classList.contains("shopify-section-header-sticky")
					) {
						header.classList.remove("have-background");
					}
				//}
			});

			headerObserver.observe(header);
		};
		
		const hasOverlay = header.classList.contains("has-overlay");

		if (hasOverlay) {
			header.addEventListener("mouseenter", addBackground);

			header.addEventListener("focus", addBackground);

			header.addEventListener("focusin", addBackground);

			header.addEventListener("mouseleave", removeBackground);

			header.addEventListener("focusout", removeBackground);

			document.addEventListener("click", (e) => {
				if (!header.contains(e.target)) {
					removeBackground();
				}
			});

			document.addEventListener("DOMContentLoaded", () => {
				const firstSection = document.querySelector(
					"main .shopify-section:first-child:not(.not-margin) .section--has-overlay:not(.article-template__header)"
				);
				if (!firstSection) return;
				const headerTop = document.querySelector(".shopify-section-header .header__top");
				const headerSearch = document.querySelector(".shopify-section-header .search__content");
				const headerBottom = document.querySelector(".shopify-section-header .header__bottom");
				
				let isSectionVisible = false;
				const observer = new IntersectionObserver(
					([entry]) => {
						if (entry.isIntersecting && !isSectionVisible) {
							isSectionVisible = true;
							headerTop.classList.add("color-background-3");
							headerSearch.classList.add("color-background-3");
							headerBottom.classList.add("color-background-3");
							header.classList.add("entering-section", "color-background-3");
						} else if (!entry.isIntersecting && isSectionVisible) {
							isSectionVisible = false;
							header.classList.remove("entering-section");
						}
					},
					{ threshold: 0.15 }
				);

				if (firstSection) {
					observer.observe(firstSection);
				}

				window.addEventListener("scroll", () => {
					if (isSectionVisible) {
						header.classList.add("entering-section", "color-background-3");
						headerTop.classList.add("color-background-3");
						headerBottom.classList.add("color-background-3");
						headerSearch.classList.add("color-background-3");
					}
				});
			});
		}
		
		const observer = new ResizeObserver((entries) => {
			entries.forEach((entry) => {
				calcMegaMenuPosition(header);
				checkMegaSubmenuPosition(header);
				calcHeaderHeightTop(header);
				calcSearchModalPosition(header);
			});
		});

		observer.observe(header);
	}

	document.addEventListener('DOMContentLoaded', initHeader)
	document.addEventListener('shopify:section:load', initHeader)
})()
// Browsing History: custom element owns all localStorage read/write, cleaning, and recording
if (!customElements.get('browsing-history-wrapper')) {
	const BrowsingHistoryWrapperClass = class BrowsingHistoryWrapper extends HTMLElement {
		static STORAGE_KEY = '__browsing_history';
		static MAX_ITEMS = 5;
		static EXPIRATION_DAYS = 7;

		/**
		 * Get browsing history from localStorage, filter expired, and persist cleaned list.
		 */
		static getBrowsingHistory() {
			try {
				const stored = localStorage.getItem(this.STORAGE_KEY);
				if (!stored) return [];

				const history = JSON.parse(stored);
				const now = Date.now();
				const expirationTime = this.EXPIRATION_DAYS * 24 * 60 * 60 * 1000;

				const validHistory = history.filter(item => {
					if (!item.timestamp) return false;
					return (now - item.timestamp) < expirationTime;
				});

				if (validHistory.length !== history.length) {
					this.saveBrowsingHistory(validHistory);
				}

				return validHistory;
			} catch (error) {
				console.warn('Could not read browsing history from localStorage:', error);
				return [];
			}
		}

		static saveBrowsingHistory(browsingHistory) {
			try {
				localStorage.setItem(this.STORAGE_KEY, JSON.stringify(browsingHistory));
				window.dispatchEvent(new CustomEvent('browsing-history-updated', {
					detail: { browsingHistory }
				}));
			} catch (error) {
				console.warn('Could not save browsing history to localStorage:', error);
			}
		}

		/**
		 * Gather current product data from the page (product pages only). Returns null if not on a product page.
		 */
		static getCurrentProductData() {
			if (!window.location.pathname.includes('/products/')) return null;

			let productData = null;
			const productSection = document.querySelector('section[data-product-id]');
			if (productSection) {
				productData = {
					id: productSection.dataset.productId || window.location.pathname,
					url: productSection.dataset.productUrl || window.location.href,
					title: productSection.dataset.productTitle || document.title,
					image: productSection.dataset.productImage || null,
					price: productSection.dataset.productPrice ? parseFloat(productSection.dataset.productPrice) : null,
					currency: productSection.dataset.productCurrency || null,
					timestamp: Date.now()
				};
			}

			if (!productData) {
				const structuredDataScript = document.querySelector('script[type="application/ld+json"]');
				if (structuredDataScript) {
					try {
						const jsonData = JSON.parse(structuredDataScript.textContent);
						if (jsonData['@type'] === 'Product') {
							productData = {
								id: jsonData['@id'] || window.location.pathname,
								url: jsonData.url || window.location.href,
								title: jsonData.name || document.title,
								image: jsonData.image?.[0] || jsonData.image || null,
								price: jsonData.offers?.price ? parseFloat(jsonData.offers.price) : null,
								currency: jsonData.offers?.priceCurrency || null,
								timestamp: Date.now()
							};
						}
					} catch (error) {
						console.warn('Could not parse structured data:', error);
					}
				}
			}

			if (!productData) {
				const productTitle = document.querySelector('h1.product__title, h1[data-product-title]')?.textContent?.trim() || document.title;
				const productImage = document.querySelector('img[data-product-image], .product__media img')?.src || null;
				productData = {
					id: window.location.pathname,
					url: window.location.href,
					title: productTitle,
					image: productImage,
					price: null,
					currency: null,
					timestamp: Date.now()
				};
			}

			return productData;
		}

		/**
		 * Record a product visit: dedupe, prepend, trim to MAX_ITEMS, save.
		 */
		static addProductVisit(productData) {
			let browsingHistory = this.getBrowsingHistory();
			browsingHistory = browsingHistory.filter(item => item.id !== productData.id);
			browsingHistory.unshift(productData);
			browsingHistory = browsingHistory.slice(0, this.MAX_ITEMS);
			this.saveBrowsingHistory(browsingHistory);
		}

		constructor() {
			super();
			this.handleStorageUpdate = this.handleStorageUpdate.bind(this);
			this.handleHistoryUpdate = this.handleHistoryUpdate.bind(this);
		}

		connectedCallback() {
			this.render();
			window.addEventListener('browsing-history-updated', this.handleHistoryUpdate);
			window.addEventListener('storage', this.handleStorageUpdate);
		}

		disconnectedCallback() {
			window.removeEventListener('browsing-history-updated', this.handleHistoryUpdate);
			window.removeEventListener('storage', this.handleStorageUpdate);
		}

		handleHistoryUpdate() {
			this.render();
		}

		handleStorageUpdate(event) {
			if (event.key === BrowsingHistoryWrapperClass.STORAGE_KEY && event.newValue) {
				this.render();
			}
		}

		getBrowsingHistory() {
			return BrowsingHistoryWrapperClass.getBrowsingHistory();
		}

		formatPrice(price, currency) {
			if (!price) return '';
			
			// Shopify prices are typically stored in cents, convert to dollars
			const priceInDollars = price / 100;
			
			// Use Shopify's money format if available, otherwise use Intl
			if (window.Shopify && window.Shopify.formatMoney) {
				return window.Shopify.formatMoney(price, '{{amount}}');
			}
			
			// Fallback to Intl.NumberFormat
			if (currency) {
				return new Intl.NumberFormat('en-US', {
					style: 'currency',
					currency: currency
				}).format(priceInDollars);
			}
			
			// Final fallback: simple dollar format
			return `$${priceInDollars.toFixed(2)}`;
		}

		render() {
			const history = this.getBrowsingHistory();
			if (history.length === 0) {
				this.innerHTML = '<div class="browsing-history__empty">No browsing history yet.</div>';
				return;
			}
			const truncateString = (str, maxLength) => {
				const ending = '...';
				if (str.length > maxLength) {
					// Truncate and add the ending, accounting for the ending's length
					return str.slice(0, maxLength - ending.length) + ending;
				} else {
					return str;
				}
			};
			const historyHTML = history.map(product => {
				const priceHTML = product.price 
					? `<div class="browsing-history__price">${this.formatPrice(product.price, product.currency)}</div>`
					: '';
				
				const imageHTML = product.image
					? `<img src="${product.image}" alt="${this.escapeHtml(product.title)}" class="browsing-history__image" loading="lazy">`
					: '<div class="browsing-history__image-placeholder">No image</div>';

				return `
					<a href="${this.escapeHtml(product.url)}" class="browsing-history__item">
						${imageHTML}
						<div class="browsing-history__content">
							<div class="browsing-history__title">${this.escapeHtml(truncateString(product.title, 25))}</div>
							${priceHTML}
						</div>
					</a>
				`;
			}).join('');

			this.innerHTML = `
				<div class="browsing-history__container">
					${historyHTML}
				</div>
			`;
		}

		escapeHtml(text) {
			const div = document.createElement('div');
			div.textContent = text;
			return div.innerHTML;
		}
	};

	customElements.define('browsing-history-wrapper', BrowsingHistoryWrapperClass);

	// Minimal tracking: gather product data and record via the custom element's static API
	(function () {
		function trackProductVisit() {
			const productData = BrowsingHistoryWrapperClass.getCurrentProductData();
			if (productData) BrowsingHistoryWrapperClass.addProductVisit(productData);
		}
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', trackProductVisit);
		} else {
			trackProductVisit();
		}
		window.addEventListener('popstate', trackProductVisit);
	})();
}